// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/style.scss
// module id = 1079
// module chunks = 62